<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>消息管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.messageType" placeholder="请选择消息类型">
					<el-option key="" label="请选择消息类型" value=""></el-option>
					<el-option key="1" label="企业公告" value="1"></el-option>
					<el-option key="2" label="业务消息" value="2"></el-option>
					<el-option key="3" label="其他消息" value="3"></el-option>
				</el-select>
				&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				@selection-change="handleSelectionChange"
				stripe
            >
				<el-table-column type="selection" width="50" align="center"></el-table-column>
				<el-table-column prop="messageType" label="消息类型" :formatter="messageTypeFormatter" width = "100px"></el-table-column>
				<el-table-column prop="notifyType" label="弹窗类型" width = "120px">
					<template slot-scope="scope">
						{{scope.row.notifyType==2?"通过":(scope.row.notifyType==1?"警告":(scope.row.notifyType==3?"拒绝":"提示"))}}
					</template>
				</el-table-column>
                <el-table-column prop="title" label="标题"></el-table-column>
				<el-table-column prop="assignType" label="指派方式" :formatter="assignTypeFormatter" width = "100px"></el-table-column>
				<el-table-column prop="expirationTime" label="有效期" width = "160px"></el-table-column>
				<el-table-column prop="url" label="跳转页面"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width = "160px"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-popover
							placement="right"
							width="400"
							trigger="click" v-if="scope.row.assignType > 1">
							<el-table :data="getAssignTo(scope.$index, scope.row)" style="font-size:14px">
								<el-table-column property="assignTo" label="指派对象"></el-table-column>
							</el-table>
							<el-button type="text" slot="reference" icon="el-icon-user-solid">查看指派对象</el-button>
						</el-popover>&nbsp;
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="发布新消息" :visible.sync="editVisible" width="50%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-form-item label="消息类型" prop="messageType">
					<el-select v-model="form.messageType" placeholder="请选择消息类型">
						<el-option key="" label="请选择消息类型" value=""></el-option>
						<el-option key="1" label="企业公告" value="1"></el-option>
						<el-option key="2" label="业务消息" value="2"></el-option>
						<el-option key="3" label="其他消息" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="消息标题" prop="title">
					<el-input v-model="form.title"></el-input>
				</el-form-item>
				<el-form-item label="消息内容" prop="content">
					<el-input type=textarea :rows=5 v-model="form.content"> </el-input>
				</el-form-item>
				<el-form-item label="弹窗类型" prop="notifyType">
					<el-select v-model="form.notifyType" placeholder="请选择弹窗类型" style="width:350px;">
						<el-option key="" label="请选择弹窗类型" value=""></el-option>
						<el-option key="0" label="提示" value="0"></el-option>
						<el-option key="1" label="警告" value="1"></el-option>
						<el-option key="2" label="通过" value="2"></el-option>
						<el-option key="3" label="拒绝" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="消息提醒方式" prop="messageLevel">
					<el-select v-model="form.messageLevel" placeholder="请选择消息提醒方式" style="width:350px;">
						<el-option key="" label="请选择消息提醒方式" value=""></el-option>
						<el-option key="0" label="不提醒" value="0"></el-option>
						<el-option key="1" label="订阅提醒，登录弹出" value="1"></el-option>
						<el-option key="2" label="订阅提醒，登录不弹出" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="指派方式" prop="assignType">
					<el-select v-model="form.assignType" placeholder="请选择指派方式" style="width:350px;" @change="assignTypeChange">
						<el-option key="" label="请选择指派方式" value=""></el-option>
						<el-option key="1" label="全部人" value="1"></el-option>
						<el-option key="2" label="指定部门" value="2"></el-option>
						<el-option key="3" label="指定人" value="3"></el-option>
					</el-select>
					&nbsp;&nbsp;<el-checkbox v-model="props.multiple" v-if="form.assignType > 1" @change="multiple">多选</el-checkbox>
				</el-form-item>
				<el-form-item label="指派对象" prop="assignToInfo" v-if="form.assignType > 1">
					<el-cascader
						:options="options"
						:props="props"
						collapse-tags
						v-model="form.assignToInfo" style="width:350px;" filterable clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="有效期" prop="expirationTime">
					<el-date-picker
						type="datetime"
						placeholder="请选择有效期"
						v-model="form.expirationTime"
						value-format="yyyy-MM-dd"
						style="width:185px;"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="跳转页面" prop="url">
					<el-input v-model="form.url"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { getUnreadQzone, fetchMessageData, deleteMessage, saveMessage, getMessage, getDepartmentUserTree } from '../../../api/index'
export default {
    name: 'message',
    data() {
		
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			controll:{},
			rules: {
				messageType: [{ required: true, message: '请选择消息类型', trigger: 'blur' }],
                title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
                content: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
				notifyType: [{ required: true, message: '请选择消息提醒类型', trigger: 'blur' }],
				messageLevel: [{ required: true, message: '请选择消息提醒方式', trigger: 'blur' }],
				assignType: [{ required: true, message: '请选择指派方式', trigger: 'blur' }],
				assignTo: [{ required: true, message: '请选择指派对象', trigger: 'blur' }],
				expirationTime: [{ required: true, message: '请选择消息有效期', trigger: 'blur' }]
            },
			props:{
				multiple:false,
				checkStrictly: false
			},
			options:[],
			allOptions:[],
			departmentOptions:[],
			messageTypeMapping:{"":"全部消息","0":"系统消息","1":"业务消息","2":"公告消息","3":"其他消息"},
			statusMapping:{"":"全部状态","0":"未读","1":"已读"},
			assignToMapping:{"1":"全公司","2":"指定部门","3":"指定人"},
			departmentMapping:{},
			multipleSelection:[]
        };
    },
    created() {
		this.controll = getControll("message");
		this.getSubmitUser();
    },
    methods: {
		// 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		messageTypeFormatter(row, column, cellValue) {
			return this.messageTypeMapping[cellValue];
		},
		assignTypeFormatter(row, column, cellValue) {
			return this.assignToMapping[cellValue];
		},
		getAssignTo(index, row) {
			if (row.assignType==1) {
				return "";
			}
			let names = [];
			for (var index in row.assignTos) {
				let key = row.assignTos[index] + "-" +(row.assignType==2?"":"1");
				names.push({"assignTo":this.departmentMapping[key]["name"]});
			}
			return names;
		},
		handleAdd() {
			this.form = {};
			this.$set(this.props, "multiple", false);
			this.editVisible = true;
		},
		saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					let assignTos = [];
					if (this.form.assignToInfo) {
						if (Array.isArray(this.form.assignToInfo[0])) {
							for (var i = 0; i < this.form.assignToInfo.length; i++) {
								let item = this.form.assignToInfo[i];
								assignTos.push(item[item.length - 1]);
							}
						} else {
							assignTos.push(this.form.assignToInfo[this.form.assignToInfo.length - 1]);
						}
					}
					this.$set(this.form, "assignTos", assignTos);
					saveMessage(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		handleShow() {
			getMessage(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取消息详情失败！` + res.message);
				}
			})
		},
		handleMessageTypeCommand(command) {
			this.query.selectName = this.messageTypeMapping[command];
		},
		handleStatusCommand(command) {
			this.query.statusName = this.statusMapping[command];
		},
		// 获取 easy-mock 的模拟数据
        getData() {
            fetchMessageData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取消息数据失败！" + res.message);
				}
            });
        },
		getSubmitUser() {
			getDepartmentUserTree().then(res => {
				if (res.code == 0 ) {
					this.allOptions = res.data;
					this.departmentOptions = JSON.parse(JSON.stringify(res.data));
					this.getDepartmentMapping(this.departmentOptions, undefined, undefined);
					this.getData();
				} else {
					this.$message.error("获取用户信息失败，" + res.message);
				}
			});
		},
		getDepartmentMapping(nodes, parent, parentName) {
			for(let i = nodes.length - 1; i >= 0; i--) {
				let node = nodes[i];
				let mapping = {};
				let departmentInfo = [];
				let name = "";
				if (parent) {
					departmentInfo = departmentInfo.concat(parent);
					name = parentName;
				}
				departmentInfo.push(node.value);
				name = (name?name + "/":"") + node.label;
				mapping["name"] = name;
				mapping["info"] = departmentInfo;
				this.departmentMapping[node.value+"-"+(node.sign?node.sign:"")] = mapping;
				if (node.children && node.children.length > 0) {
					this.getDepartmentMapping(node.children, departmentInfo, name);
					if (node.children.length == 0) {
						node.children = undefined;
					}
				}
				if (node.sign == 1) {
					nodes.splice(i, 1);
				}
			}
		},
		multiple() {
			this.form.assignToInfo = [];
		},
		assignTypeChange(val) {
			this.form.assignToInfo = [];
			this.options = (val==3?this.allOptions:this.departmentOptions);
		},
		handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteMessage([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		// 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteMessage(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		// 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
